<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">Overseas&nbsp;Test&nbsp;Tool&nbsp;System</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`cancel全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>                
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img src="../../assets/img/img.jpg" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        {{username}}
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="modifypwd">Modify PWD</el-dropdown-item>
                        <el-dropdown-item divided command="loginout">Exit</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <el-dialog title="MODIFY PASSWORD" :visible.sync="modifypwddialogFormVisible">
            <el-form>
                <el-form-item label="Old Password" :label-width="formLabelWidth">
                    <el-input type="password" v-model="modifypwdform.OldPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="New Password" :label-width="formLabelWidth">
                    <el-input type="password" v-model="modifypwdform.NewPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="New Password Again" :label-width="formLabelWidth">
                    <el-input type="password" v-model="modifypwdform.NewPasswordAgain" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="modifypwddialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="Modifypwd();modifypwddialogFormVisible = false;">OK</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import bus from '../common/bus';
import { ModifyPWDData } from '../../api/index'
export default {
    data() {
        return {
            collapse: false,
            fullscreen: false,
            username: localStorage.getItem("userName"),
            message: 2,
            modifypwddialogFormVisible: false,
            modifypwdform: {
                OldPassword:"",
                NewPassword:"",
                NewPasswordAgain:""
            }
        };
    },
    computed: {
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                this.$store.dispatch("UserLoginOut");
                this.$router.push('/overseastest/login');
            }else if(command == 'modifypwd') {
                this.modifypwddialogFormVisible = true;
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        },
        Modifypwd() {
            let token = this.$store.getters.idToken;
            let ModifypwdFormData = {
                OldPassword : this.modifypwdform.OldPassword,
                NewPassword : this.modifypwdform.NewPassword,
                NewPasswordAgain : this.modifypwdform.NewPasswordAgain
            }
            if (this.modifypwdform.NewPassword == this.modifypwdform.NewPasswordAgain) {
                ModifyPWDData ({
                    oldpassword : this.modifypwdform.OldPassword,
                    newpassword : this.modifypwdform.NewPassword
                },token).then(res => {
                    if (res.code == 1) {
                        this.$message({
                            message: 'Modify Success！！！',
                            type: 'success'
                        });
                        this.$router.push({path:'/overseastest/login'});          
                    }
                }).catch(error => {
                    this.$message({
                        message: 'Modify Failed(Please check old passsword right)',
                        type: 'warning'
                    })
                });                
            } else {
                this.$message({
                    message: 'Two new password are not the same！！！',
                    type: 'warning'
                })
            }
        }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 70px;
}
.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
</style>
